import { useQuery } from "react-query"
import { QueryReturnType } from "../../services/networking.service"
import ENDPOINTS from "../../services/endPoints"

export const useGetActiveUsers = (): QueryReturnType<any> => {
    return useQuery<never, never, any>(
        [ENDPOINTS.ACTIVE_USERS],
        {
            retry: false, // Don't retry on failure
            refetchOnWindowFocus: false, // Don't refetch when window regains focus
            refetchOnMount: false, // Don't refetch on component mount
            refetchOnReconnect: false, // Don't refetch on reconnect
            refetchInterval: false, // Disable automatic refetching
            staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
            cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
            notifyOnChangeProps: ['data', 'error', 'refetch', 'isRefetching', 'isSuccess', 'isLoading'],
            onError: (error: any) => {
                console.error('Dashboard API Error:', error);
                // Don't throw error to prevent infinite loops
            },
        }
    )
}